import Relay from 'react-relay';

export class ResourceRoute extends Relay.Route {
  static routeName = 'ResourceRoute';
  static paramDefinitions = {
      id: {required: true}
  };
  static queries = {
    resource: () => Relay.QL`
        query { resource(id: $id) }
    `,
  };
};

export class ViewerRoute extends Relay.Route {
  static routeName = 'ViewerRoute';
  static queries = {
    viewer: () => Relay.QL`
        query { viewer }
    `,
  };
};

export class SearchRoute extends Relay.Route {
  static routeName = 'SearchRoute';
  static queries = {
    viewer: () => Relay.QL`
        query { viewer }
    `,
  };
};




// WEBPACK FOOTER //
// ./webapp/relay/routes.js